<template>
    <div class="publish-demand">
        <div class="publish-demand_left">
            <template v-for="(step, index) in processList">
                <div :class="['step-item', { active: currentStep === step.id }]" @click="handleToStep(step)" :key="step.id">
                    <img :src="step.img" alt="" />

                    <div class="step-info">
                        <div class="step-info_title">{{ `0${index + 1}` }} {{ step.label }}</div>
                        <div class="step-info_desc">{{ step.desc }}</div>
                    </div>
                </div>

                <i class="el-icon-arrow-down" v-if="index < processList.length - 1" :key="`icon_${step.id}`"></i>
            </template>
        </div>

        <div class="publish-demand_box">
            <component
                ref="componentRef"
                :is="currentComponent"
                @cancel="handleCancel"
                @prev="handlePrev"
                @next="handleNext"
                @submit="handleSubmit"
            ></component>
        </div>
    </div>
</template>

<script>
import SettingTitle from "./modules/task/SettingTitle.vue";
import SettingMode from "./modules/task/SettingMode.vue";
import SettingDesc from "./modules/task/SettingDesc.vue";
import taskApi from "../../../apis/task";
import { getRoleRouter, request } from "./util";

export default {
    data() {
        return {
            maxStep: 1,
            currentStep: 1,
            processList: [
                {
                    id: 1,
                    label: "填写标题",
                    desc: "一句话描述需求",
                    img: require("@/assets/img/task-center/demand-1.png"),
                },

                {
                    id: 2,
                    label: "选择模式",
                    desc: "选择任务模式",
                    img: require("@/assets/img/task-center/demand-2.png"),
                },

                {
                    id: 3,
                    label: "添加描述",
                    desc: "添加需求信息",
                    img: require("@/assets/img/task-center/demand-3.png"),
                },
            ],

            formData: {
                id: 0,
                task_name: "", // 任务名称
                task_type: undefined, // 需求类型ID
                task_mode: 1, // 交易模式，1-招募模式，2-竞单模式
                task_start_time: undefined, // 任务截止时间，mode-1-报名截止时间，mode-2-交稿截止时间
                task_end_time: undefined, // 任务期望完成时间
                task_budget: undefined, // 任务预算
                task_description: "", // 任务描述
                task_files: [], // 任务文件列表
            },

            request: request(),
        };
    },

    computed: {
        currentComponent() {
            const componentMap = {
                1: SettingTitle,
                2: SettingMode,
                3: SettingDesc,
            };

            return componentMap[this.currentStep];
        },
    },

    methods: {
        handleCancel() {
            this.$confirm("确定取消", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                customClass: "ek-confirm warning",
            }).then(() => {
                const toPath = getRoleRouter("index");
                if (toPath) {
                    this.$router.push({ path: toPath });
                }
            });
        },

        handleToStep(step) {
            if (step.id <= this.maxStep && step.id !== this.currentStep) {
                this.currentStep = step.id;

                this.$nextTick(() => {
                    this.$refs.componentRef?.initData?.(this.formData);
                });
            }
        },

        handlePrev() {
            this.currentStep -= 1;
        },

        handleNext(val) {
            Object.assign(this.formData, val);
            this.currentStep += 1;
            this.maxStep += 1;

            this.$nextTick(() => {
                this.$refs.componentRef?.initData?.(this.formData);
            });
        },

        handleSubmit(val) {
            const params = Object.assign({}, this.formData, val);

            this.request.axiosPost(taskApi.saveTask, params, (res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);

                    const toPath = getRoleRouter("index");
                    if (toPath) {
                        this.$router.push({ path: toPath });
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 获取详情
        getDetail() {
            const params = {
                id: Number(this.$route.query.id),
            };

            const _this = this;
            this.request.axiosGetBy(taskApi.getTask, params, (res) => {
                if (res.code === 200) {
                    const data = res.data;

                    if (data) {
                        _this.formData = {
                            id: data.id,
                            task_name: data.task_name,
                            task_type: data.task_type,
                            task_mode: data.task_mode,
                            task_start_time: data.task_start_time,
                            task_end_time: data.task_end_time,
                            task_budget: data.task_budget,
                            task_description: data.task_description,
                            task_files: data.task_files || [],
                        };

                        _this.$refs.componentRef?.initData?.(_this.formData);
                    }
                } else {
                    _this.$message.error(res.message);
                }
            });
        },
    },

    created() {
        if (this.$route.query.id) {
            this.getDetail();
        }
    },
};
</script>

<style lang="scss" scoped>
.publish-demand {
    --min-height: calc(100vh - 100px - 80px);

    background-color: #ffffff;
    padding: 40px;
    padding-left: 0;
    display: flex;

    &_left {
        width: 282px;
        min-height: var(--min-height);
        border-right: 1px solid #eeeeee;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;

        .step-item {
            width: 210px;
            height: 86px;
            background-color: #f5f7fa;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 16px;
            opacity: 0.5;

            img {
                width: 40px;
                height: 40px;
                object-fit: cover;
            }

            .step-info {
                &_title {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 16px;
                    color: #000000;
                }

                &_desc {
                    margin-top: 5px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 12px;
                    color: #666666;
                }
            }

            &.active {
                border: 1px solid #594fed;
                opacity: 1;
            }
        }

        .el-icon-arrow-down {
            font-size: 30px;
        }
    }

    &_box {
        flex: 1;
        width: calc(100% - 282px);
    }
}
</style>
